import { render } from "./AIML.vue?vue&type=template&id=f94a9e52&ts=true"
import script from "./AIML.vue?vue&type=script&lang=ts"
export * from "./AIML.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__